import md5 from 'md5';
import { BaseUser } from './BaseUser';
import { BaseUserBuilder } from './UserBuilder';

export { BaseUser, BaseUserBuilder };

export const defaultHashUserId = (id: string): string => md5(id);
